import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function passwordValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value as string;

    if (!value) {
      return { required: true };
    }

    let lower = 0;
    let upper = 0;
    let number = 0;
    let special = 0;

    for (let i = 0; i < value.length; i++) {
      const char = value[i];
      if (/[a-z]/.test(char)) lower++;
      else if (/[A-Z]/.test(char)) upper++;
      else if (/[0-9]/.test(char)) number++;
      else if (/[!@#\$%^&*]/.test(char)) special++;
    }

    const categories = [lower, upper, number, special].filter((c) => c > 0).length;

    if (value.length < 8) {
      return { passwordTooShort: true };
    }

    if (categories < 3) {
      return { passwordWeak: true };
    }

    return null;
  };
}
